module.exports = {
    api: {
        baseUrl: '/api',
        uploadUrl: 'https://www.qiyuanwh.com/api/file/setAttachment?fileType=img'
    },
    devServe: {
        host: 'dev.qiyuanwh.com',
        target: 'https://www.qiyuanwh.com'
    }
}